<template>
  <div>
    <div id="print-report">
      <!-- PRINT ONLY -->
      <div class="caption d-none d-print-block mb-3">
        <!-- Print Only -->
        <HeaderPrint />
        <!-- / Print Only -->
        <div>
          {{ $t("periodLabel") }}
          {{ $date.formatRange(rangeDate) }}
        </div>
      </div>

      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn small light @click="$printReport()">
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("btnPrint") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('labelSearch')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :dense="$vuetify.breakpoint.smAndDown"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id_lancamento="{ item }">
            <v-btn @click="$copy(item.id_lancamento)" x-small>{{
              item.id_lancamento
            }}</v-btn>
          </template>

          <template v-slot:item.nome_arrecadador="{ item }">
            <a
              class="light-green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_collector,
                  'regionalManager/collectors/getCollector'
                )
              "
            >
              <v-icon color="light-green" small>mdi-account-cash</v-icon>
              {{ item.nome_arrecadador }}
            </a>
          </template>
          <template v-slot:item.categoria="{ item }">
            {{ categoria(item.categoria) }}
          </template>
          <template v-slot:item.data_registro="{ item }">
            <span class="caption">{{ item.data_registro }}</span>
          </template>
          <template v-slot:item.valor="{ item }">
            <span :class="getColor(item.valor)">{{ item.valor }}</span>
          </template>
        </v-data-table>
      </v-card>

      <div class="d-flex justify-end">
        <v-card class="d-flex flex-column mb-3 pa-3" style="max-width: 740px">
          <div class="pa-2">
            {{ $t("justResume") }}
            <div class="caption">{{ rangeDateUI }}</div>
          </div>
          <v-divider></v-divider>

          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>{{ $t("fullCollection") }}</td>
                  <td :class="getColor(retreat)" class="text-right">
                    {{ retreat }}
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("totalDepositPremiumPayment") }}</td>
                  <td :class="getColor(depositPayment)" class="text-right">
                    {{ depositPayment }}
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("totalMiscellaneousDeposit") }}</td>
                  <td :class="getColor(depositDiverse)" class="text-right">
                    {{ depositDiverse }}
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("totalChargeback") }}</td>
                  <td :class="getColor(reversal)" class="text-right">
                    {{ reversal }}
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("finalBalanceLabel") }}</td>
                  <td :class="getColor(balance)" class="text-right">
                    {{ balance }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "regional-manager-financial-collection-entry",
  components: {
    HeaderPrint,
  },
  data: () => ({
    items: [],
    search: "",

    status: 1,

    //Resume
    retreat: 0,
    depositPayment: 0,
    depositDiverse: 0,
    reversal: 0,
    balance: 0,
    count: 0,
  }),
  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_collector() {
      return this.$store.state.filters.autocompleteCollectors.id;
    },
    rangeDateUI() {
      return this.$store.state.rangeUI;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    headers() {
      return [
        { text: this.$t("idLabel"), value: "id_lancamento" },
        { text: this.$t("name"), value: "nome_arrecadador" },
        { text: this.$t("categoryLabel"), value: "categoria" },
        { text: this.$t("date"), value: "data_registro" },
        { text: this.$t("valueLabel"), value: "valor", align: "right" },
      ];
    },
  },
  watch: {
    saveFilters(val) {
      val && this.reportCashCollectors();
    },
  },
  methods: {
    async reportCashCollectors() {
      this.search = "";

      const body = {
        ...this.rangeDate,
        id_collector: this.id_collector,
      };

      const request = await this.$request.post(
        "/regionalManager/financial/reportCashCollectors",
        body
      );

      if (request.length == 0) {
        this.items = [];
        return;
      }

      this.items = request.cashEntrys;

      // handle date
      this.items.forEach((item) => {
        item.data_registro = new Date(
          item.data_registro.replace(" ", "T")
        ).toLocaleString();
      });

      this.resume(this.items);
    },

    resume(items) {
      this.retreat = 0;
      this.depositPayment = 0;
      this.depositDiverse = 0;
      this.reversal = 0;
      this.balance = 0;

      items.forEach((item) => {
        let { categoria } = item;
        if (categoria == 1) {
          this.retreat = this.retreat + Number(item.valor);
        }
        if (categoria == 2) {
          this.depositPayment = this.depositPayment + Number(item.valor);
        }
        if (categoria == 3) {
          this.depositDiverse = this.depositDiverse + Number(item.valor);
        }
        if (categoria == 4) {
          this.reversal = this.reversal + Number(item.valor);
        }

        this.balance = this.balance + Number(item.valor);
      });

      this.retreat = this.retreat.toFixed(2);
      this.depositPayment = this.depositPayment.toFixed(2);
      this.depositDiverse = this.depositDiverse.toFixed(2);
      this.reversal = this.reversal.toFixed(2);
      this.balance = this.balance.toFixed(2);
    },

    getColor(value) {
      if (value == 0) return "grey--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
    categoria: function(id) {
      const translateCategory = {
        1: this.$t("collection"),
        2: this.$t("prizeDepositPayment"),
        3: this.$t("miscellaneouDeposit"),
        4: this.$t("chargeback"),
      };

      return translateCategory[id];
    },
  },
  filters: {
    // dateFormat: function (val) {
    //   var date = new Date(val).toLocaleString();
    //   return date;
    // },
  },
};
</script>
